import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const SupBox = ({ children, marginDirection, type = "flex", }) => (_jsx(Box, Object.assign({ as: "span" }, (type === "flex"
    ? { transform: "translateY(-0.5em)" }
    : { verticalAlign: "super" }), { marginRight: marginDirection === "rtl" ? "spacing.2" : "spacing.none", marginLeft: marginDirection === "ltr" ? "spacing.2" : "spacing.none", unsafe_style: { fontSize: "0.75em", lineHeight: "1" }, children: children })));
